module.exports = __webpack_public_path__ + "4f589f4867dbd57elist-3.87c42f5a.png";